<div class="animate__animated fadeIn animate__delay-1s w-100 h-100" [ngStyle]="{'background': restaurant.color}">
  <!-- Cabezote -->
  <div class="row">
    <div class="col-12">
      <!-- Boton de idioma -->
      <div class="position-absolute mt-2 mr-4 buttonClose  animate__animated animate__delay-2s bounceIn">
        <button class="btn btn-icon p-2" [ngStyle]="{'background': menu.color,'color': menu.colorText,'border-color': menu.color}" type="button" (click)="selectLanguage()"
          *ngIf="language? 'ES':'EN'">
          <i class="fas fa-globe-americas m--1" [ngClass]="{'fa-flag': language == 'ES', 'fa-flag-usa' : language == 'EN' }"></i>
          <span class="btn-inner--text">{{ language }}</span>
        </button>
      </div>
      <img [src]="restaurant?.logo" alt="" class="img-fluid w-100">
    </div>
  </div>
  <!-- Listado de publicidades -->
  <div class="row">
    <div class="col-12 pl-4 pr-4 pt-2">
      <app-ads [id]="restaurant.id" [isHomeAd]="true"></app-ads>
    </div>
  </div>

  <!-- Listado de productos recomendados-->
  <app-item-image [section]="section" [menu]="menu" class="animate__animated fadeIn animate__delay-2s" *ngIf="menu.colorText"></app-item-image>

  <!-- Boton de ver carta -->
  <div class="row justify-content-center animate__animated fadeIn animate__delay-2s" *ngIf="viewButtonMenu()">
    <div class="col-10 text-center p-4">
      <button class="btn btn-danger btn-block {{menu.fontText}}" type="button" (click)="close()"
        [ngStyle]="{'color': menu.color, 'background-color': menu.colorText, 'border-color': menu.colorText}">
        {{ language === 'ES'? 'VER MENÚ': 'SHOW MENU'}}</button>
    </div>
  </div>

  <!-- Botones de cartas en PDF ingles y español -->
  <div class="row justify-content-center animate__animated fadeIn animate__delay-1s p-3" *ngIf="!viewButtonMenu()">
    <div class="col-6" (click)="goMenuPDF('imagesMenuEn')">
      <img class="img-fluid" [src]="restaurant.imgFood" alt="">
    </div>
    <div class="col-6" (click)="goMenuPDF('imagesMenuEs')">
      <img class="img-fluid" [src]="restaurant.imgDrinks" alt="">
    </div>
  </div>
</div>